// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.whatsapp-numbers {
    padding: 20px;
}

.page-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
}

.info-banner {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 30px;
}

.info-banner h3 {
    margin-top: 0;
    margin-bottom: 10px;
}

.info-banner ul {
    margin: 10px 0 0 20px;
}

.info-banner li {
    margin: 5px 0;
}

/* Numbers Grid */
.numbers-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 20px;
}

.number-card {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
}

.agent-type-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 14px;
    font-weight: bold;
}

.agent-type-badge[data-type="customer_care"] {
    background: #e3f2fd;
    color: #1976d2;
}

.agent-type-badge[data-type="tutor"] {
    background: #f3e5f5;
    color: #7b1fa2;
}

.status-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: bold;
}

.status-badge[data-active="true"] {
    background: #e8f5e9;
    color: #2e7d32;
}

.status-badge[data-active="false"] {
    background: #ffebee;
    color: #c62828;
}

.card-body {
    padding: 20px;
}

.card-body h3 {
    margin: 0 0 15px 0;
    color: #333;
}

.number-info {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 14px;
}

.info-row .label {
    color: #666;
    font-weight: 500;
    min-width: 120px;
}

.info-row .value {
    color: #333;
    text-align: right;
    flex: 1 1;
}

.info-row .value.code {
    font-family: 'Courier New', monospace;
    font-size: 12px;
    background: #f5f5f5;
    padding: 2px 6px;
    border-radius: 3px;
}

.info-row .value.code.small {
    font-size: 11px;
    word-break: break-all;
}

.info-row .value.verified {
    color: #2e7d32;
    font-weight: bold;
}

.info-row .value.unverified {
    color: #f57c00;
    font-weight: bold;
}

.card-actions {
    display: flex;
    gap: 10px;
    padding: 15px 20px;
    background: #f8f9fa;
    border-top: 1px solid #e9ecef;
}

.card-actions button {
    flex: 1 1;
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.2s;
}

.btn-secondary {
    background: #6c757d;
    color: white;
}

.btn-secondary:hover {
    background: #5a6268;
}

.btn-toggle {
    background: #ffc107;
    color: #333;
}

.btn-toggle:hover {
    background: #e0a800;
}

.btn-toggle.active {
    background: #28a745;
    color: white;
}

.btn-toggle.active:hover {
    background: #218838;
}

.btn-danger {
    background: #dc3545;
    color: white;
}

.btn-danger:hover {
    background: #c82333;
}

/* Empty State */
.empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #666;
}

.empty-state p {
    margin: 10px 0;
    font-size: 16px;
}

/* Modal */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
}

/* Modal stacking order: agent selection (bottom) -> pin (middle) -> mobile (top) */
.modal-overlay.overlay-agent-selection {
    z-index: 1000;
}

.modal-overlay.overlay-pin {
    z-index: 1010;
}

.modal-overlay.overlay-mobile {
    z-index: 1020;
}

.modal-content {
    background: white;
    border-radius: 8px;
    width: 90%;
    max-width: 550px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e9ecef;
}

.modal-header h2 {
    margin: 0;
}

.modal-body {
    padding: 20px;
}

.close-button {
    background: none;
    border: none;
    font-size: 32px;
    cursor: pointer;
    color: #999;
    line-height: 1;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-button:hover {
    color: #333;
}

.modal form {
    padding: 20px;
}

.form-group {
    margin-bottom: 20px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
    color: #333;
}

.form-group input,
.form-group select {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
}

.form-group input:focus,
.form-group select:focus {
    outline: none;
    border-color: #007bff;
}

.form-group small {
    display: block;
    margin-top: 5px;
    color: #666;
    font-size: 12px;
}

.modal-actions {
    display: flex;
    gap: 10px;
    padding-top: 20px;
    border-top: 1px solid #e9ecef;
}

.modal-actions button {
    flex: 1 1;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.btn-primary {
    background: #007bff;
    color: white;
}

.btn-primary:hover {
    background: #0056b3;
}

/* Agent Selection Modal */
.agent-selection-modal {
    max-width: 550px;
}

.modal-description {
    margin-bottom: 20px;
    color: #666;
}

.phones-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.phone-card {
    padding: 15px;
    background: #f5f5f5;
    border-radius: 8px;
    border: 1px solid #ddd;
}

.phone-info {
    margin-bottom: 10px;
}

.phone-info strong {
    font-size: 16px;
}

.phone-info p {
    margin: 5px 0;
    color: #666;
}

.agent-options {
    display: flex;
    gap: 10px;
}

.agent-option {
    flex: 1 1;
    padding: 12px 10px;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    cursor: pointer;
    text-align: center;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
}

.agent-option input[type="radio"] {
    margin-bottom: 5px;
}

.agent-option strong {
    display: block;
    font-size: 14px;
}

.agent-option .agent-desc {
    font-size: 12px;
    color: #666;
    display: block;
}

.agent-option.selected.customer-care {
    background: #e3f2fd;
    border: 2px solid #2196f3;
}

.agent-option.selected.tutor {
    background: #e8f5e9;
    border: 2px solid #4caf50;
}

.agent-option:hover:not(.selected) {
    background: #f8f9fa;
    border-color: #aaa;
}

/* Mobile Responsive Styles */
@media screen and (max-width: 768px) {
    .whatsapp-numbers {
        padding: 10px;
    }

    .page-header {
        flex-direction: column;
        gap: 15px;
        align-items: stretch;
        text-align: center;
    }

    .page-header h1 {
        font-size: 1.5rem;
    }

    .page-header>div {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .page-header button {
        width: 100%;
    }

    .info-banner {
        padding: 15px;
        margin-bottom: 20px;
    }

    .numbers-grid {
        grid-template-columns: 1fr;
    }

    /* Modal Mobile Fixes */
    .modal-overlay {
        padding: 10px;
        align-items: flex-start;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    .modal-content {
        width: 100%;
        max-width: 100% !important;
        max-height: none;
        margin: 10px 0;
        border-radius: 12px;
    }

    .modal-header {
        padding: 15px;
        position: sticky;
        top: 0;
        background: white;
        z-index: 10;
    }

    .modal-header h2 {
        font-size: 1.1rem;
        padding-right: 40px;
    }

    .modal-body {
        padding: 15px;
    }

    .close-button {
        position: absolute;
        right: 15px;
        top: 15px;
    }

    /* Agent Selection Modal Mobile */
    .agent-selection-modal {
        max-width: 100% !important;
    }

    .agent-options {
        flex-direction: column;
    }

    .agent-option {
        padding: 15px;
    }

    .agent-option strong {
        font-size: 16px;
    }

    .agent-option .agent-desc {
        font-size: 13px;
    }

    .modal-actions {
        flex-direction: column-reverse;
        margin-top: 20px;
    }

    .modal-actions button {
        width: 100%;
        padding: 14px 20px;
        font-size: 16px;
    }

    /* Form inputs mobile */
    .form-group input,
    .form-group select {
        font-size: 16px;
        /* Prevents iOS zoom on focus */
    }

    .card-actions {
        flex-direction: column;
    }

    .info-row {
        flex-direction: column;
        gap: 3px;
    }

    .info-row .label {
        min-width: auto;
    }

    .info-row .value {
        text-align: left;
    }

    .empty-state {
        padding: 30px 15px;
    }

    .prerequisites {
        text-align: left;
    }

    .prerequisites ul {
        padding-left: 20px;
    }
}

/* Extra small devices */
@media screen and (max-width: 375px) {
    .modal-header h2 {
        font-size: 1rem;
    }

    .info-banner h3 {
        font-size: 1.1rem;
    }

    .agent-type-badge,
    .status-badge {
        font-size: 11px;
        padding: 4px 8px;
    }
}

/* PIN Verification Modal */
.pin-verification-modal {
    max-width: 550px;
}

.pin-info-banner {
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
    border: 2px solid #ff9800;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
}

.pin-info-banner p {
    margin: 5px 0;
    color: #e65100;
}

.pin-request-section,
.pin-verify-section {
    margin-bottom: 20px;
}

.pin-request-section h4,
.pin-verify-section h4 {
    margin: 0 0 10px 0;
    color: #333;
}

.pin-request-section p,
.pin-verify-section p {
    margin: 0 0 15px 0;
    color: #666;
}

/* Code Method Options (SMS/VOICE) */
.code-method-options {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;
}

.method-option {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 15px;
    background: #f5f5f5;
    border: 2px solid #ddd;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.method-option input[type="radio"] {
    display: none;
}

.method-option .method-icon {
    font-size: 28px;
    margin-bottom: 5px;
}

.method-option strong {
    font-size: 14px;
}

.method-option.selected {
    background: #e3f2fd;
    border-color: #2196f3;
}

.method-option:hover:not(.selected) {
    background: #f0f0f0;
    border-color: #bbb;
}

/* PIN Input */
.pin-input-container {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}

.pin-input {
    width: 200px;
    height: 60px;
    font-size: 32px;
    text-align: center;
    letter-spacing: 10px;
    font-family: 'Courier New', monospace;
    border: 2px solid #2196f3;
    border-radius: 8px;
    background: #f5f5f5;
    outline: none;
}

.pin-input:focus {
    border-color: #1976d2;
    background: #fff;
}

/* Full Width Button */
.btn-full-width {
    width: 100%;
    padding: 15px 20px;
    font-size: 16px;
}

/* Resend PIN Section */
.pin-resend {
    text-align: center;
    margin-top: 20px;
    padding-top: 15px;
    border-top: 1px solid #eee;
}

.pin-resend p {
    margin: 0 0 5px 0;
    color: #666;
    font-size: 14px;
}

.btn-link {
    background: none;
    border: none;
    color: #2196f3;
    cursor: pointer;
    font-size: 14px;
    text-decoration: underline;
    padding: 0;
}

.btn-link:hover {
    color: #1976d2;
}

.btn-link:disabled {
    color: #aaa;
    cursor: not-allowed;
}

/* Mobile Responsive for PIN Modal */
@media screen and (max-width: 768px) {
    .pin-verification-modal {
        max-width: 100% !important;
    }

    .code-method-options {
        flex-direction: column;
        gap: 10px;
    }

    .method-option {
        flex-direction: row;
        justify-content: center;
        gap: 10px;
        padding: 12px;
    }

    .method-option .method-icon {
        font-size: 24px;
        margin-bottom: 0;
    }

    .pin-input {
        width: 100%;
        max-width: 250px;
        height: 55px;
        font-size: 28px;
        letter-spacing: 8px;
    }
}

/* Fix for mobile modal visibility */
@media screen and (max-width: 768px) {

    /* Ensure modals are above everything */
    .modal-overlay {
        position: fixed !important;
        top: 0 !important;
        left: 0 !important;
        right: 0 !important;
        bottom: 0 !important;
        width: 100% !important;
        height: 100% !important;
        z-index: 9999 !important;
        background: rgba(0, 0, 0, 0.7) !important;
        display: flex !important;
        align-items: flex-start !important;
        justify-content: center !important;
        padding-top: 20px !important;
        overflow-y: auto !important;
        -webkit-overflow-scrolling: touch;
    }

    .modal-content {
        position: relative !important;
        width: calc(100% - 20px) !important;
        margin: 10px !important;
        max-height: calc(100vh - 40px) !important;
        overflow-y: auto !important;
        -webkit-overflow-scrolling: touch;
        transform: none !important;
    }

    /* Agent Selection Modal Mobile */
    .agent-selection-modal,
    .pin-verification-modal,
    .qr-modal {
        width: calc(100% - 20px) !important;
        max-width: none !important;
    }

    /* Fix touch scrolling inside modal */
    .modal-body {
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        max-height: calc(100vh - 150px);
    }

    /* Profile Settings Mobile */
    .profile-settings-content {
        padding: 12px !important;
    }

    .profile-photo-container {
        flex-direction: column !important;
        align-items: center !important;
    }

    .profile-actions {
        flex-direction: column !important;
    }

    .profile-actions button {
        width: 100% !important;
    }
}

/* ==========================================================================
   Business Profile Settings Section
   ========================================================================== */

.profile-settings-section {
    border-top: 2px solid #e0e0e0;
    margin-top: 20px;
    background: linear-gradient(to bottom, #f8f9fa, #ffffff);
    border-radius: 0 0 8px 8px;
}

.profile-toggle-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
    padding: 16px 24px;
    background: linear-gradient(to right, #f0f4f8, #e8eef4);
    border: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    text-align: left;
    transition: all 0.3s ease;
    border-radius: 0 0 8px 8px;
}

.profile-toggle-btn:hover {
    background: linear-gradient(to right, #e3eaf2, #d9e2ec);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.profile-toggle-icon {
    font-size: 12px;
    color: #4a5568;
    transition: transform 0.3s ease;
    font-weight: bold;
}

.profile-sync-badge {
    margin-left: auto;
    padding: 5px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
}

.profile-sync-badge.synced {
    background: #e8f5e9;
    color: #2e7d32;
}

.profile-settings-content {
    padding: 20px;
    background: #fafafa;
    border-top: 1px solid #e9ecef;
}

/* Profile Photo */
.profile-photo-section {
    margin-bottom: 20px;
}

.profile-photo-section>label {
    display: block;
    font-weight: 600;
    margin-bottom: 10px;
    color: #333;
}

.profile-photo-container {
    display: flex;
    align-items: center;
    gap: 15px;
}

.profile-photo-preview {
    position: relative;
    width: 80px;
    height: 80px;
}

.profile-photo-preview img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid #e9ecef;
}

.profile-photo-preview .btn-small {
    position: absolute;
    bottom: -5px;
    right: -5px;
    font-size: 10px;
    padding: 2px 6px;
}

.profile-photo-placeholder {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #e9ecef;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;
}

.profile-photo-placeholder span {
    font-size: 24px;
}

.profile-photo-placeholder small {
    font-size: 10px;
    margin-top: 2px;
}

.profile-hint {
    display: block;
    font-size: 12px;
    color: #666;
    margin-top: 5px;
}

/* Profile Form */
.profile-form-group {
    margin-bottom: 15px;
}

.profile-form-group>label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 600;
    margin-bottom: 8px;
    color: #333;
    font-size: 14px;
}

.profile-form-group .char-count {
    font-weight: normal;
    font-size: 12px;
    color: #999;
}

.profile-form-group input,
.profile-form-group textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 14px;
    transition: border-color 0.2s;
    box-sizing: border-box;
}

.profile-form-group input:focus,
.profile-form-group textarea:focus {
    outline: none;
    border-color: #2196f3;
    box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);
}

.profile-form-group textarea {
    resize: vertical;
    min-height: 80px;
}

/* Sync Info */
.profile-sync-info {
    padding: 10px 15px;
    background: #e8f5e9;
    border-radius: 6px;
    margin-bottom: 15px;
    font-size: 13px;
    color: #2e7d32;
}

/* Profile Actions */
.profile-actions {
    display: flex;
    gap: 10px;
    padding-top: 10px;
    border-top: 1px solid #e9ecef;
}

.profile-actions button {
    flex: 1 1;
    padding: 10px 16px;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
}

.profile-actions .btn-secondary {
    background: #6c757d;
    color: white;
}

.profile-actions .btn-secondary:hover:not(:disabled) {
    background: #5a6268;
}

.profile-actions .btn-primary {
    background: #25d366;
    color: white;
}

.profile-actions .btn-primary:hover:not(:disabled) {
    background: #1da851;
}

.profile-actions button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Small Buttons */
.btn-small {
    padding: 4px 8px;
    font-size: 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
}

.btn-small.btn-secondary {
    background: #6c757d;
    color: white;
}

.btn-small.btn-danger {
    background: #dc3545;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/WhatsAppNumbers.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,SAAO;AACX;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,UAAU;AACV;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA,mFAAmF;AACnF;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;IACf,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,6BAA6B;AAC7B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,oBAAoB;QACpB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA,uBAAuB;IACvB;QACI,aAAa;QACb,uBAAuB;QACvB,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,WAAW;QACX,0BAA0B;QAC1B,gBAAgB;QAChB,cAAc;QACd,mBAAmB;IACvB;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,MAAM;QACN,iBAAiB;QACjB,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;IACb;;IAEA,iCAAiC;IACjC;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,8BAA8B;QAC9B,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,eAAe;IACnB;;IAEA,uBAAuB;IACvB;;QAEI,eAAe;QACf,+BAA+B;IACnC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA,wBAAwB;AACxB;IACI;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;QACf,gBAAgB;IACpB;AACJ;;AAEA,2BAA2B;AAC3B;IACI,gBAAgB;AACpB;;AAEA;IACI,6DAA6D;IAC7D,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;AACf;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,qCAAqC;IACrC,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA,oCAAoC;AACpC;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,eAAe;QACf,mBAAmB;IACvB;AACJ;;AAEA,oCAAoC;AACpC;;IAEI,uCAAuC;IACvC;QACI,0BAA0B;QAC1B,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;QACpB,sBAAsB;QACtB,uBAAuB;QACvB,wBAAwB;QACxB,yCAAyC;QACzC,wBAAwB;QACxB,kCAAkC;QAClC,kCAAkC;QAClC,4BAA4B;QAC5B,2BAA2B;QAC3B,iCAAiC;IACrC;;IAEA;QACI,6BAA6B;QAC7B,mCAAmC;QACnC,uBAAuB;QACvB,yCAAyC;QACzC,2BAA2B;QAC3B,iCAAiC;QACjC,0BAA0B;IAC9B;;IAEA,iCAAiC;IACjC;;;QAGI,mCAAmC;QACnC,0BAA0B;IAC9B;;IAEA,qCAAqC;IACrC;QACI,gBAAgB;QAChB,iCAAiC;QACjC,+BAA+B;IACnC;;IAEA,4BAA4B;IAC5B;QACI,wBAAwB;IAC5B;;IAEA;QACI,iCAAiC;QACjC,8BAA8B;IAClC;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;;+EAE+E;;AAE/E;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,wDAAwD;IACxD,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,uDAAuD;IACvD,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,uDAAuD;IACvD,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".whatsapp-numbers {\n    padding: 20px;\n}\n\n.page-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n.info-banner {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    padding: 20px;\n    border-radius: 8px;\n    margin-bottom: 30px;\n}\n\n.info-banner h3 {\n    margin-top: 0;\n    margin-bottom: 10px;\n}\n\n.info-banner ul {\n    margin: 10px 0 0 20px;\n}\n\n.info-banner li {\n    margin: 5px 0;\n}\n\n/* Numbers Grid */\n.numbers-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n    gap: 20px;\n}\n\n.number-card {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n}\n\n.card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px 20px;\n    background: #f8f9fa;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.agent-type-badge {\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.agent-type-badge[data-type=\"customer_care\"] {\n    background: #e3f2fd;\n    color: #1976d2;\n}\n\n.agent-type-badge[data-type=\"tutor\"] {\n    background: #f3e5f5;\n    color: #7b1fa2;\n}\n\n.status-badge {\n    padding: 6px 12px;\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.status-badge[data-active=\"true\"] {\n    background: #e8f5e9;\n    color: #2e7d32;\n}\n\n.status-badge[data-active=\"false\"] {\n    background: #ffebee;\n    color: #c62828;\n}\n\n.card-body {\n    padding: 20px;\n}\n\n.card-body h3 {\n    margin: 0 0 15px 0;\n    color: #333;\n}\n\n.number-info {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.info-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    font-size: 14px;\n}\n\n.info-row .label {\n    color: #666;\n    font-weight: 500;\n    min-width: 120px;\n}\n\n.info-row .value {\n    color: #333;\n    text-align: right;\n    flex: 1;\n}\n\n.info-row .value.code {\n    font-family: 'Courier New', monospace;\n    font-size: 12px;\n    background: #f5f5f5;\n    padding: 2px 6px;\n    border-radius: 3px;\n}\n\n.info-row .value.code.small {\n    font-size: 11px;\n    word-break: break-all;\n}\n\n.info-row .value.verified {\n    color: #2e7d32;\n    font-weight: bold;\n}\n\n.info-row .value.unverified {\n    color: #f57c00;\n    font-weight: bold;\n}\n\n.card-actions {\n    display: flex;\n    gap: 10px;\n    padding: 15px 20px;\n    background: #f8f9fa;\n    border-top: 1px solid #e9ecef;\n}\n\n.card-actions button {\n    flex: 1;\n    padding: 8px 16px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.2s;\n}\n\n.btn-secondary {\n    background: #6c757d;\n    color: white;\n}\n\n.btn-secondary:hover {\n    background: #5a6268;\n}\n\n.btn-toggle {\n    background: #ffc107;\n    color: #333;\n}\n\n.btn-toggle:hover {\n    background: #e0a800;\n}\n\n.btn-toggle.active {\n    background: #28a745;\n    color: white;\n}\n\n.btn-toggle.active:hover {\n    background: #218838;\n}\n\n.btn-danger {\n    background: #dc3545;\n    color: white;\n}\n\n.btn-danger:hover {\n    background: #c82333;\n}\n\n/* Empty State */\n.empty-state {\n    text-align: center;\n    padding: 60px 20px;\n    color: #666;\n}\n\n.empty-state p {\n    margin: 10px 0;\n    font-size: 16px;\n}\n\n/* Modal */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n}\n\n/* Modal stacking order: agent selection (bottom) -> pin (middle) -> mobile (top) */\n.modal-overlay.overlay-agent-selection {\n    z-index: 1000;\n}\n\n.modal-overlay.overlay-pin {\n    z-index: 1010;\n}\n\n.modal-overlay.overlay-mobile {\n    z-index: 1020;\n}\n\n.modal-content {\n    background: white;\n    border-radius: 8px;\n    width: 90%;\n    max-width: 550px;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 1px solid #e9ecef;\n}\n\n.modal-header h2 {\n    margin: 0;\n}\n\n.modal-body {\n    padding: 20px;\n}\n\n.close-button {\n    background: none;\n    border: none;\n    font-size: 32px;\n    cursor: pointer;\n    color: #999;\n    line-height: 1;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.close-button:hover {\n    color: #333;\n}\n\n.modal form {\n    padding: 20px;\n}\n\n.form-group {\n    margin-bottom: 20px;\n}\n\n.form-group label {\n    display: block;\n    margin-bottom: 5px;\n    font-weight: 500;\n    color: #333;\n}\n\n.form-group input,\n.form-group select {\n    width: 100%;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    font-size: 14px;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n    outline: none;\n    border-color: #007bff;\n}\n\n.form-group small {\n    display: block;\n    margin-top: 5px;\n    color: #666;\n    font-size: 12px;\n}\n\n.modal-actions {\n    display: flex;\n    gap: 10px;\n    padding-top: 20px;\n    border-top: 1px solid #e9ecef;\n}\n\n.modal-actions button {\n    flex: 1;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.btn-primary {\n    background: #007bff;\n    color: white;\n}\n\n.btn-primary:hover {\n    background: #0056b3;\n}\n\n/* Agent Selection Modal */\n.agent-selection-modal {\n    max-width: 550px;\n}\n\n.modal-description {\n    margin-bottom: 20px;\n    color: #666;\n}\n\n.phones-list {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.phone-card {\n    padding: 15px;\n    background: #f5f5f5;\n    border-radius: 8px;\n    border: 1px solid #ddd;\n}\n\n.phone-info {\n    margin-bottom: 10px;\n}\n\n.phone-info strong {\n    font-size: 16px;\n}\n\n.phone-info p {\n    margin: 5px 0;\n    color: #666;\n}\n\n.agent-options {\n    display: flex;\n    gap: 10px;\n}\n\n.agent-option {\n    flex: 1;\n    padding: 12px 10px;\n    background: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    cursor: pointer;\n    text-align: center;\n    transition: all 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 5px;\n}\n\n.agent-option input[type=\"radio\"] {\n    margin-bottom: 5px;\n}\n\n.agent-option strong {\n    display: block;\n    font-size: 14px;\n}\n\n.agent-option .agent-desc {\n    font-size: 12px;\n    color: #666;\n    display: block;\n}\n\n.agent-option.selected.customer-care {\n    background: #e3f2fd;\n    border: 2px solid #2196f3;\n}\n\n.agent-option.selected.tutor {\n    background: #e8f5e9;\n    border: 2px solid #4caf50;\n}\n\n.agent-option:hover:not(.selected) {\n    background: #f8f9fa;\n    border-color: #aaa;\n}\n\n/* Mobile Responsive Styles */\n@media screen and (max-width: 768px) {\n    .whatsapp-numbers {\n        padding: 10px;\n    }\n\n    .page-header {\n        flex-direction: column;\n        gap: 15px;\n        align-items: stretch;\n        text-align: center;\n    }\n\n    .page-header h1 {\n        font-size: 1.5rem;\n    }\n\n    .page-header>div {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .page-header button {\n        width: 100%;\n    }\n\n    .info-banner {\n        padding: 15px;\n        margin-bottom: 20px;\n    }\n\n    .numbers-grid {\n        grid-template-columns: 1fr;\n    }\n\n    /* Modal Mobile Fixes */\n    .modal-overlay {\n        padding: 10px;\n        align-items: flex-start;\n        overflow-y: auto;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .modal-content {\n        width: 100%;\n        max-width: 100% !important;\n        max-height: none;\n        margin: 10px 0;\n        border-radius: 12px;\n    }\n\n    .modal-header {\n        padding: 15px;\n        position: sticky;\n        top: 0;\n        background: white;\n        z-index: 10;\n    }\n\n    .modal-header h2 {\n        font-size: 1.1rem;\n        padding-right: 40px;\n    }\n\n    .modal-body {\n        padding: 15px;\n    }\n\n    .close-button {\n        position: absolute;\n        right: 15px;\n        top: 15px;\n    }\n\n    /* Agent Selection Modal Mobile */\n    .agent-selection-modal {\n        max-width: 100% !important;\n    }\n\n    .agent-options {\n        flex-direction: column;\n    }\n\n    .agent-option {\n        padding: 15px;\n    }\n\n    .agent-option strong {\n        font-size: 16px;\n    }\n\n    .agent-option .agent-desc {\n        font-size: 13px;\n    }\n\n    .modal-actions {\n        flex-direction: column-reverse;\n        margin-top: 20px;\n    }\n\n    .modal-actions button {\n        width: 100%;\n        padding: 14px 20px;\n        font-size: 16px;\n    }\n\n    /* Form inputs mobile */\n    .form-group input,\n    .form-group select {\n        font-size: 16px;\n        /* Prevents iOS zoom on focus */\n    }\n\n    .card-actions {\n        flex-direction: column;\n    }\n\n    .info-row {\n        flex-direction: column;\n        gap: 3px;\n    }\n\n    .info-row .label {\n        min-width: auto;\n    }\n\n    .info-row .value {\n        text-align: left;\n    }\n\n    .empty-state {\n        padding: 30px 15px;\n    }\n\n    .prerequisites {\n        text-align: left;\n    }\n\n    .prerequisites ul {\n        padding-left: 20px;\n    }\n}\n\n/* Extra small devices */\n@media screen and (max-width: 375px) {\n    .modal-header h2 {\n        font-size: 1rem;\n    }\n\n    .info-banner h3 {\n        font-size: 1.1rem;\n    }\n\n    .agent-type-badge,\n    .status-badge {\n        font-size: 11px;\n        padding: 4px 8px;\n    }\n}\n\n/* PIN Verification Modal */\n.pin-verification-modal {\n    max-width: 550px;\n}\n\n.pin-info-banner {\n    background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);\n    border: 2px solid #ff9800;\n    border-radius: 8px;\n    padding: 15px;\n    margin-bottom: 20px;\n}\n\n.pin-info-banner p {\n    margin: 5px 0;\n    color: #e65100;\n}\n\n.pin-request-section,\n.pin-verify-section {\n    margin-bottom: 20px;\n}\n\n.pin-request-section h4,\n.pin-verify-section h4 {\n    margin: 0 0 10px 0;\n    color: #333;\n}\n\n.pin-request-section p,\n.pin-verify-section p {\n    margin: 0 0 15px 0;\n    color: #666;\n}\n\n/* Code Method Options (SMS/VOICE) */\n.code-method-options {\n    display: flex;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.method-option {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 15px;\n    background: #f5f5f5;\n    border: 2px solid #ddd;\n    border-radius: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.method-option input[type=\"radio\"] {\n    display: none;\n}\n\n.method-option .method-icon {\n    font-size: 28px;\n    margin-bottom: 5px;\n}\n\n.method-option strong {\n    font-size: 14px;\n}\n\n.method-option.selected {\n    background: #e3f2fd;\n    border-color: #2196f3;\n}\n\n.method-option:hover:not(.selected) {\n    background: #f0f0f0;\n    border-color: #bbb;\n}\n\n/* PIN Input */\n.pin-input-container {\n    display: flex;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.pin-input {\n    width: 200px;\n    height: 60px;\n    font-size: 32px;\n    text-align: center;\n    letter-spacing: 10px;\n    font-family: 'Courier New', monospace;\n    border: 2px solid #2196f3;\n    border-radius: 8px;\n    background: #f5f5f5;\n    outline: none;\n}\n\n.pin-input:focus {\n    border-color: #1976d2;\n    background: #fff;\n}\n\n/* Full Width Button */\n.btn-full-width {\n    width: 100%;\n    padding: 15px 20px;\n    font-size: 16px;\n}\n\n/* Resend PIN Section */\n.pin-resend {\n    text-align: center;\n    margin-top: 20px;\n    padding-top: 15px;\n    border-top: 1px solid #eee;\n}\n\n.pin-resend p {\n    margin: 0 0 5px 0;\n    color: #666;\n    font-size: 14px;\n}\n\n.btn-link {\n    background: none;\n    border: none;\n    color: #2196f3;\n    cursor: pointer;\n    font-size: 14px;\n    text-decoration: underline;\n    padding: 0;\n}\n\n.btn-link:hover {\n    color: #1976d2;\n}\n\n.btn-link:disabled {\n    color: #aaa;\n    cursor: not-allowed;\n}\n\n/* Mobile Responsive for PIN Modal */\n@media screen and (max-width: 768px) {\n    .pin-verification-modal {\n        max-width: 100% !important;\n    }\n\n    .code-method-options {\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .method-option {\n        flex-direction: row;\n        justify-content: center;\n        gap: 10px;\n        padding: 12px;\n    }\n\n    .method-option .method-icon {\n        font-size: 24px;\n        margin-bottom: 0;\n    }\n\n    .pin-input {\n        width: 100%;\n        max-width: 250px;\n        height: 55px;\n        font-size: 28px;\n        letter-spacing: 8px;\n    }\n}\n\n/* Fix for mobile modal visibility */\n@media screen and (max-width: 768px) {\n\n    /* Ensure modals are above everything */\n    .modal-overlay {\n        position: fixed !important;\n        top: 0 !important;\n        left: 0 !important;\n        right: 0 !important;\n        bottom: 0 !important;\n        width: 100% !important;\n        height: 100% !important;\n        z-index: 9999 !important;\n        background: rgba(0, 0, 0, 0.7) !important;\n        display: flex !important;\n        align-items: flex-start !important;\n        justify-content: center !important;\n        padding-top: 20px !important;\n        overflow-y: auto !important;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .modal-content {\n        position: relative !important;\n        width: calc(100% - 20px) !important;\n        margin: 10px !important;\n        max-height: calc(100vh - 40px) !important;\n        overflow-y: auto !important;\n        -webkit-overflow-scrolling: touch;\n        transform: none !important;\n    }\n\n    /* Agent Selection Modal Mobile */\n    .agent-selection-modal,\n    .pin-verification-modal,\n    .qr-modal {\n        width: calc(100% - 20px) !important;\n        max-width: none !important;\n    }\n\n    /* Fix touch scrolling inside modal */\n    .modal-body {\n        overflow-y: auto;\n        -webkit-overflow-scrolling: touch;\n        max-height: calc(100vh - 150px);\n    }\n\n    /* Profile Settings Mobile */\n    .profile-settings-content {\n        padding: 12px !important;\n    }\n\n    .profile-photo-container {\n        flex-direction: column !important;\n        align-items: center !important;\n    }\n\n    .profile-actions {\n        flex-direction: column !important;\n    }\n\n    .profile-actions button {\n        width: 100% !important;\n    }\n}\n\n/* ==========================================================================\n   Business Profile Settings Section\n   ========================================================================== */\n\n.profile-settings-section {\n    border-top: 2px solid #e0e0e0;\n    margin-top: 20px;\n    background: linear-gradient(to bottom, #f8f9fa, #ffffff);\n    border-radius: 0 0 8px 8px;\n}\n\n.profile-toggle-btn {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    width: 100%;\n    padding: 16px 24px;\n    background: linear-gradient(to right, #f0f4f8, #e8eef4);\n    border: none;\n    cursor: pointer;\n    font-size: 16px;\n    font-weight: 600;\n    color: #2c3e50;\n    text-align: left;\n    transition: all 0.3s ease;\n    border-radius: 0 0 8px 8px;\n}\n\n.profile-toggle-btn:hover {\n    background: linear-gradient(to right, #e3eaf2, #d9e2ec);\n    transform: translateY(-1px);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.profile-toggle-icon {\n    font-size: 12px;\n    color: #4a5568;\n    transition: transform 0.3s ease;\n    font-weight: bold;\n}\n\n.profile-sync-badge {\n    margin-left: auto;\n    padding: 5px 12px;\n    border-radius: 12px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.profile-sync-badge.synced {\n    background: #e8f5e9;\n    color: #2e7d32;\n}\n\n.profile-settings-content {\n    padding: 20px;\n    background: #fafafa;\n    border-top: 1px solid #e9ecef;\n}\n\n/* Profile Photo */\n.profile-photo-section {\n    margin-bottom: 20px;\n}\n\n.profile-photo-section>label {\n    display: block;\n    font-weight: 600;\n    margin-bottom: 10px;\n    color: #333;\n}\n\n.profile-photo-container {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n}\n\n.profile-photo-preview {\n    position: relative;\n    width: 80px;\n    height: 80px;\n}\n\n.profile-photo-preview img {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    object-fit: cover;\n    border: 3px solid #e9ecef;\n}\n\n.profile-photo-preview .btn-small {\n    position: absolute;\n    bottom: -5px;\n    right: -5px;\n    font-size: 10px;\n    padding: 2px 6px;\n}\n\n.profile-photo-placeholder {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    background: #e9ecef;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: #999;\n}\n\n.profile-photo-placeholder span {\n    font-size: 24px;\n}\n\n.profile-photo-placeholder small {\n    font-size: 10px;\n    margin-top: 2px;\n}\n\n.profile-hint {\n    display: block;\n    font-size: 12px;\n    color: #666;\n    margin-top: 5px;\n}\n\n/* Profile Form */\n.profile-form-group {\n    margin-bottom: 15px;\n}\n\n.profile-form-group>label {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-weight: 600;\n    margin-bottom: 8px;\n    color: #333;\n    font-size: 14px;\n}\n\n.profile-form-group .char-count {\n    font-weight: normal;\n    font-size: 12px;\n    color: #999;\n}\n\n.profile-form-group input,\n.profile-form-group textarea {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    font-size: 14px;\n    transition: border-color 0.2s;\n    box-sizing: border-box;\n}\n\n.profile-form-group input:focus,\n.profile-form-group textarea:focus {\n    outline: none;\n    border-color: #2196f3;\n    box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.1);\n}\n\n.profile-form-group textarea {\n    resize: vertical;\n    min-height: 80px;\n}\n\n/* Sync Info */\n.profile-sync-info {\n    padding: 10px 15px;\n    background: #e8f5e9;\n    border-radius: 6px;\n    margin-bottom: 15px;\n    font-size: 13px;\n    color: #2e7d32;\n}\n\n/* Profile Actions */\n.profile-actions {\n    display: flex;\n    gap: 10px;\n    padding-top: 10px;\n    border-top: 1px solid #e9ecef;\n}\n\n.profile-actions button {\n    flex: 1;\n    padding: 10px 16px;\n    border: none;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.profile-actions .btn-secondary {\n    background: #6c757d;\n    color: white;\n}\n\n.profile-actions .btn-secondary:hover:not(:disabled) {\n    background: #5a6268;\n}\n\n.profile-actions .btn-primary {\n    background: #25d366;\n    color: white;\n}\n\n.profile-actions .btn-primary:hover:not(:disabled) {\n    background: #1da851;\n}\n\n.profile-actions button:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Small Buttons */\n.btn-small {\n    padding: 4px 8px;\n    font-size: 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.btn-small.btn-secondary {\n    background: #6c757d;\n    color: white;\n}\n\n.btn-small.btn-danger {\n    background: #dc3545;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
